import { Component, Input, OnInit, SimpleChanges, inject } from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { ScoreboardService } from '../scoreboard.service';
import { MatchService } from '../../_core/services/match.service';
import { AuthService } from '../../auth/auth.service';

@Component({
  standalone: false,
  selector: 'app-sb-header',
  templateUrl: './sb-header.component.html',
  styleUrls: ['./sb-header.component.scss'],
})
export class SbHeaderComponent {
  scoreboardService = inject(ScoreboardService);
  @Input({ required: true }) match: Match
  public authService = inject(AuthService);
  batteryIcon: string;
  batteryColor: string;
  batteryPercent: number;
  showBattery: boolean = false;
  
  matchService = inject(MatchService)
  async ngOnInit() {
    this.setBatteryStatusFromDeviceMeta();  
  }  

  setBatteryStatusFromDeviceMeta() {
    const isTeamOrTournament = Boolean(this.match?.tie || this.match?.tournament);
    const user = this.authService.authUserSignal();

    const isOwner = user?._id === this.match?.dist?.owner?.toString();
    const isTracker = this.match?.trackers?.some(
      t => t.tracker?._id?.toString() === user?._id
    );
    const isAdmin = user?.role?.value === 500;

    const isAuthorized = isOwner || isTracker || isAdmin;

    this.showBattery = isTeamOrTournament && isAuthorized;    
  }
  

}
